import React from 'react';
import { Link } from 'react-router-dom';
import { Monitor, Smartphone, TrendingUp, Users, CheckCircle, Mail, HelpCircle, Share2, Sparkles, Radio, Briefcase, Megaphone, HeartHandshake, Clapperboard } from 'lucide-react';
import ServiceCTA from '../components/ServiceCTA';
import TrustBadge from '../components/TrustBadge';
import GlobalSolutions from '../components/GlobalSolutions';
import Seo from '../components/Seo';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

const Home = () => {
  const reasons = [
    {
      icon: <CheckCircle className="w-10 h-10" />,
      title: '全部まるごとお任せ',
      description: 'SNS、ホームページ、宣伝など、デジタル周りのことは全てお任せください。'
    },
    {
      icon: <CheckCircle className="w-10 h-10" />,
      title: '初めてでも安心のやさしい対応',
      description: '専門用語なし。わかりやすい説明で丁寧にサポートいたします。'
    },
    {
      icon: <CheckCircle className="w-10 h-10" />,
      title: 'オーダーメイドのご提案',
      description: 'お店に合わせたプランをご提案。小規模店舗でも始めやすい料金。'
    },
    {
      icon: <CheckCircle className="w-10 h-10" />,
      title: '続けやすい安心価格',
      description: '強引な営業は一切ありません。小さな質問でも大歓迎です。'
    }
  ];

  const services = [
    {
      icon: <Monitor className="w-12 h-12" />,
      title: 'Webサイト制作',
      description: 'スマホ対応・写真加工・文章作成込みで、お店の魅力が伝わるサイトを制作します。',
      link: '/services/web',
      image: 'https://images.unsplash.com/photo-1542744094-3a31f272c490?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHx3ZWIlMjBkZXNpZ24lMjBsYXB0b3B8ZW58MHx8fHwxNzY0NjQ5NDc0fDA&ixlib=rb-4.1.0&q=85'
    },
    {
      icon: <Smartphone className="w-12 h-12" />,
      title: 'SNS運用サポート',
      description: '写真加工・投稿文作成・投稿代行まで、忙しい店主さんをサポートします。',
      link: '/services/sns',
      image: 'https://images.unsplash.com/photo-1644771571408-f2b3b8782f41?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxzbWFydHBob25lJTIwaW5zdGFncmFtfGVufDB8fHx8MTc2NDY0OTQ3OXww&ixlib=rb-4.1.0&q=85'
    },
    {
      icon: <TrendingUp className="w-12 h-12" />,
      title: 'マーケティングサポート',
      description: 'Googleマップ最適化・口コミ対策・キャンペーン設計で来店につながる導線を作ります。',
      link: '/services/marketing',
      image: 'https://images.unsplash.com/photo-1619468129361-605ebea04b44?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxtYXAlMjBsb2NhdGlvbnxlbnwwfHx8fDE3NjQ2NDk0ODV8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      icon: <Users className="w-12 h-12" />,
      title: 'ビジネスコンサルティング',
      description: '売上アップ・店舗導線改善・メニュー改善など、経営に関するお悩みを一緒に解決します。',
      link: '/services/consulting',
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGNvbnN1bHRpbmd8ZW58MHx8fHwxNzY0NjQ5NDg5fDA&ixlib=rb-4.1.0&q=85'
    }
  ];

  const digitalSupport = [
    {
      icon: <Share2 className="w-7 h-7" />,
      title: 'SNS発信サポート',
      description: 'Instagram・X などの投稿づくりや発信のコツを、無理のないペースで一緒に整えます。'
    },
    {
      icon: <Sparkles className="w-7 h-7" />,
      title: 'クリエイター支援',
      description: 'TikTok LIVE公認エージェンシーとして、配信の始め方から継続的な成長まで、一人ひとりに寄り添って支援します。'
    },
    {
      icon: <Radio className="w-7 h-7" />,
      title: 'TikTok LIVE・ライブ配信サポート',
      description: 'TikTok LIVEを活用した配信の企画・準備・配信をサポート。集客・商品PR・地域プロモーションなど目的に合わせてご提案します。'
    },
    {
      icon: <Briefcase className="w-7 h-7" />,
      title: 'オンラインビジネス支援',
      description: 'ネット販売や予約・問い合わせの仕組みづくりなど、オンライン展開を一歩ずつサポートします。'
    },
    {
      icon: <Megaphone className="w-7 h-7" />,
      title: 'デジタルマーケティング支援',
      description: '誰に・どう伝えるかを一緒に考え、お店や活動の魅力が伝わる発信を組み立てます。'
    },
    {
      icon: <HeartHandshake className="w-7 h-7" />,
      title: '地域に寄り添うプロモーション',
      description: '地域とのつながりを大切に、背伸びをしない等身大の発信を一緒に育てていきます。'
    },
    {
      icon: <Clapperboard className="w-7 h-7" />,
      title: 'ショート動画・TikTok支援',
      description: '短い動画づくりのアイデアや撮影・編集のコツを、気軽に取り入れられる形でご提案します。'
    }
  ];

  const steps = [
    { number: 1, icon: <Mail className="w-8 h-8" />, title: 'お問い合わせ', description: 'フォームまたはメールで' },
    { number: 2, icon: <Users className="w-8 h-8" />, title: '無料ヒアリング（メール）', description: 'お店のご状況をメールでお伺いします' },
    { number: 3, icon: <CheckCircle className="w-8 h-8" />, title: 'ご提案・お見積り', description: '最適なプランをご提案' },
    { number: 4, icon: <TrendingUp className="w-8 h-8" />, title: '制作・サポート開始', description: '実際の作業スタート' },
    { number: 5, icon: <CheckCircle className="w-8 h-8" />, title: '公開・アフターフォロー', description: '公開後も安心サポート' }
  ];

  const galleryImages = [
    {
      url: 'https://images.unsplash.com/photo-1601141586963-f213d2575b7f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxzb2NpYWwlMjBtZWRpYSUyMHNtYXJ0cGhvbmV8ZW58MHx8fHwxNzY0NjUzNjgyfDA&ixlib=rb-4.1.0&q=85',
      alt: 'SNS投稿作業風景'
    },
    {
      url: 'https://images.unsplash.com/photo-1758519289152-d64650d13c7d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMGNvbnN1bHRhdGlvbiUyMG1lZXRpbmd8ZW58MHx8fHwxNzY0NjUzNjk0fDA&ixlib=rb-4.1.0&q=85',
      alt: '店舗オーナーとの相談風景'
    },
    {
      url: 'https://images.unsplash.com/photo-1548345680-f5475ea5df84?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxtYXAlMjBsb2NhdGlvbnxlbnwwfHx8fDE3NjQ2NDk0ODV8MA&ixlib=rb-4.1.0&q=85',
      alt: 'Googleマップ最適化'
    }
  ];

  const faqData = [
    {
      question: 'パソコンが苦手でも大丈夫ですか?',
      answer: 'はい、大丈夫です。専門用語を使わず、やさしく説明いたします。操作も全て代行いたしますので、お任せください。'
    },
    {
      question: '写真や文章の準備は必要ですか?',
      answer: '必要ありません。お店の写真はこちらで撮影・編集いたします。文章も代わりに作成いたしますのでご安心ください。'
    },
    {
      question: '急な変更に対応できますか?',
      answer: 'はい、対応可能です。小さな修正や変更にも迅速に対応いたします。お気軽にご連絡ください。'
    },
    {
      question: 'なぜこの価格で提供できるのですか?',
      answer: '個人事業主で運営コストを抑え、地域密着でサービスを提供しているためです。小規模店舗でも始めやすい価格設定を心がけています。'
    },
    {
      question: '無理な営業はありませんか?',
      answer: '一切ありません。お店の状況やご予算に合わせて、最適なプランをご提案いたします。強引な提案はいたしませんのでご安心ください。'
    },
    {
      question: '途中でプラン変更はできますか?',
      answer: 'はい、可能です。お店の状況に合わせてプランの変更や追加ができます。お気軽にご相談ください。'
    },
    {
      question: 'ホームページの管理はどうなりますか?',
      answer: 'サーバー管理や技術的な部分は当方で行います。お客さまは、内容の修正や更新についてご相談いただく形となります。'
    },
    {
      question: 'ドメイン（URL）はどうなりますか?',
      answer: '既にお持ちのドメインがある場合は、そのままご利用いただけます。新規取得が必要な場合は、原則としてお客さま名義で取得し、設定や管理は当方でサポートいたします。'
    },
    {
      question: 'ロゴがなくても依頼できますか?',
      answer: 'はい、可能です。ロゴをお持ちの場合は、ホームページへ反映いたします。ロゴがない場合でも、テキスト中心のデザインでホームページ制作が可能です。簡易的なロゴ作成（Web利用向け）をご希望の場合は、別途ご相談ください。'
    },
    {
      question: 'SNS用の写真がないのですが…',
      answer: 'ご安心ください。実際にお店に伺い、写真撮影からご対応いたします。スマホでも素敵な写真に編集いたします。'
    },
    {
      question: 'エリア外でも対応可能ですか?',
      answer: '基本的には上郡町・赤穂市・たつの市・相生市を中心に対応していますが、その他の地域もご相談ください。オンラインで対応できるサービスもあります。'
    },
    {
      question: '契約期間はありますか?',
      answer: 'ありません。必要な期間だけご利用いただけます。'
    },
    {
      question: '出張で写真撮影は可能ですか?',
      answer: '地域により対応可能です。まずはご相談ください。'
    }
  ];

  return (
    <div>
      <Seo
        title="Sakura Local Business Support｜Japan Market Entry & Global Expansion・デジタルサポート"
        description="さくらグローバル合同会社が運営するSLBSは、日本企業の海外進出と海外企業の日本市場進出を、バイリンガルコンサルティング・AIマーケティング・ローカライズ・SEOで支援。TikTok LIVE公認エージェンシーとして、ライブ配信・SNS運用・地域プロモーションも提供します。"
        keywords="Japan Market Entry,Global Expansion,Japanese Localization,Export Support,International Marketing,Bilingual Marketing,AI Marketing,Cross-border Business,日本市場進出,海外進出支援,TikTok LIVE,ライブ配信,SNS運用,デジタルマーケティング,地域プロモーション,クリエイター支援,上郡町 ホームページ制作"
      />
      {/* Hero Section */}
      <section 
        className="relative min-h-[600px] flex items-center justify-center" 
        style={{
          backgroundImage: 'url(https://images.pexels.com/photos/2080436/pexels-photo-2080436.jpeg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-white/70"></div>
        <div className="container mx-auto px-4 py-20 relative z-10 text-center fade-in">
          <p className="text-sm md:text-base font-semibold tracking-[0.2em] uppercase mb-5" style={{ color: '#C77A93' }}>
            Empowering Businesses in Japan and Beyond
          </p>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
            地域のお店のための、<br />
            やさしいデジタル伴走サポート
          </h1>
          <p className="text-xl md:text-2xl mb-4 text-gray-700">
            ホームページやSNSのことを、無理なく一緒に整えます。
          </p>
          <p className="text-sm text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed">
            SLBSは、海外進出を目指す日本企業と、日本市場への参入を目指す海外企業の双方も支援します。
            バイリンガル対応のコンサルティングとAIを活用したデジタルマーケティングで、国境を越えたビジネスの成長をお手伝いします。
          </p>
          <Link to="/contact" className="btn-primary inline-block px-8 py-4 rounded-full text-lg font-semibold">
            無料相談はこちら
          </Link>
        </div>
      </section>

      {/* Announcement Section - TikTok LIVE Official Agency */}
      <section className="py-12 bg-white" data-testid="tiktok-announcement-section">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto rounded-2xl border border-gray-100 shadow-sm overflow-hidden" style={{ backgroundColor: '#FFF7FA' }}>
            <div className="p-8 md:p-10">
              <TrustBadge className="mb-5" />
              <h2 className="text-2xl md:text-3xl font-bold mb-4" style={{ color: '#2C2C2C' }}>
                TikTok LIVE公認エージェンシーとして認定されました
              </h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                この度、さくらグローバル合同会社はTikTok LIVE公認エージェンシーとして認定されました。
                SLBSでは、地域の事業者様やクリエイターの皆様に向けて、TikTok LIVEを活用した
                ライブ配信による集客・認知拡大・販路拡大をサポートしています。
              </p>
              <p className="text-gray-700 leading-relaxed mb-6">
                店舗・観光・地域産品・サービスなど、それぞれの魅力を全国、そして世界へ届けるための
                情報発信をお手伝いします。
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <Link
                  to="/services/tiktok-live"
                  className="btn-primary inline-flex items-center justify-center px-6 py-3 rounded-full font-medium text-sm"
                  data-testid="announcement-service-link"
                >
                  TikTok LIVEサポートを見る
                </Link>
                <Link
                  to="/news"
                  className="inline-flex items-center justify-center px-6 py-3 rounded-full font-medium text-sm border border-gray-300 text-gray-700 hover:border-[#F7C9D3] hover:text-[#C77A93] transition-colors bg-white"
                  data-testid="announcement-news-link"
                >
                  お知らせを見る
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 fade-in" style={{ color: '#2C2C2C' }}>
            選ばれる理由
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {reasons.map((reason, index) => (
              <div key={index} className="bg-gray-50 p-8 rounded-2xl hover-lift">
                <div className="mb-4" style={{ color: '#F7C9D3' }}>
                  {reason.icon}
                </div>
                <h3 className="text-xl font-semibold mb-3" style={{ color: '#2C2C2C' }}>
                  {reason.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {reason.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16" style={{ backgroundColor: '#FFF7FA' }}>
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 fade-in" style={{ color: '#2C2C2C' }}>
            サービス一覧
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {services.map((service, index) => (
              <Link
                key={index}
                to={service.link}
                className="bg-white rounded-2xl shadow-md overflow-hidden hover-lift"
              >
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <div className="mb-4" style={{ color: '#F7C9D3' }}>
                    {service.icon}
                  </div>
                  <h3 className="text-xl font-semibold mb-3" style={{ color: '#2C2C2C' }}>
                    {service.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Digital Promotion & Creator Support Section */}
      <section className="py-16 bg-white" data-testid="digital-promotion-section">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12 fade-in">
            <span className="inline-block text-xs font-semibold tracking-widest uppercase mb-3 px-4 py-1.5 rounded-full" style={{ backgroundColor: '#FFF7FA', color: '#D98AA0' }}>
              Digital Promotion &amp; Creator Support
            </span>
            <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#2C2C2C' }}>
              デジタルプロモーション・<br className="md:hidden" />クリエイター支援
            </h2>
            <p className="text-gray-600 leading-relaxed max-w-2xl mx-auto">
              地域のお店や個人で活動されるクリエイターの方が、オンラインでの発信を少しずつ広げていけるように。
              SNSやライブ配信、ショート動画などのデジタルツールを使った発信を、無理なく一緒に育てていくお手伝いをしています。
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {digitalSupport.map((item, index) => (
              <div
                key={index}
                className="bg-white p-7 rounded-2xl border border-gray-100 shadow-sm hover-lift"
                data-testid={`digital-support-card-${index}`}
              >
                <div className="w-14 h-14 rounded-xl flex items-center justify-center mb-4" style={{ backgroundColor: '#FFF7FA', color: '#D98AA0' }}>
                  {item.icon}
                </div>
                <h3 className="text-lg font-semibold mb-2" style={{ color: '#2C2C2C' }}>
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
          <p className="text-center text-sm text-gray-500 mt-10 max-w-2xl mx-auto leading-relaxed">
            ※ 一部のオンライン支援は全国対応も可能です。まずはお気軽にご相談ください。
          </p>
        </div>
      </section>

      {/* Global Business Solutions Section */}
      <GlobalSolutions />
      <section className="pb-16 -mt-4" style={{ backgroundColor: '#FFF7FA' }}>
        <div className="container mx-auto px-4 text-center">
          <Link
            to="/global-business"
            className="inline-flex items-center text-sm font-medium text-[#C77A93] hover:text-[#2C2C2C] transition-colors"
            data-testid="home-global-business-link"
          >
            Global Business Solutions の全体像を見る →
          </Link>
        </div>
      </section>

      {/* Flow Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 fade-in" style={{ color: '#2C2C2C' }}>
            ご利用の流れ
          </h2>
          <div className="max-w-4xl mx-auto">
            {steps.map((step, index) => (
              <div key={index} className="flex items-start mb-8 fade-in">
                <div className="flex-shrink-0 w-16 h-16 rounded-full flex items-center justify-center" style={{ backgroundColor: '#F7C9D3' }}>
                  <span className="text-2xl font-bold" style={{ color: '#2C2C2C' }}>{step.number}</span>
                </div>
                <div className="ml-6 flex-grow">
                  <div className="flex items-center mb-2">
                    <div style={{ color: '#2C2C2C' }}>{step.icon}</div>
                    <h3 className="text-xl font-semibold ml-3" style={{ color: '#2C2C2C' }}>
                      {step.title}
                    </h3>
                  </div>
                  <p className="text-gray-600">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-16" style={{ backgroundColor: '#FFF7FA' }}>
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" style={{ color: '#2C2C2C' }}>
            地域密着 × デジタルサポート
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {galleryImages.map((image, index) => (
              <div key={index} className="rounded-2xl overflow-hidden shadow-md hover-lift">
                <img 
                  src={image.url} 
                  alt={image.alt}
                  className="w-full h-64 object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-12">
              <HelpCircle className="w-12 h-12 mx-auto mb-4" style={{ color: '#F7C9D3' }} />
              <h2 className="text-3xl md:text-4xl font-bold" style={{ color: '#2C2C2C' }}>
                よくあるご質問
              </h2>
            </div>
            <Accordion type="single" collapsible className="w-full">
              {faqData.map((faq, index) => (
                <AccordionItem key={index} value={`item-${index}`}>
                  <AccordionTrigger className="text-left">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-600">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </section>

      {/* Contact CTA Section */}
      <ServiceCTA 
        title="まずはお気軽にご相談ください。"
        description="強引な営業は一切ありません。小さな質問でも大歓迎です。"
        buttonText="無料相談はこちら"
      />
    </div>
  );
};

export default Home;